import PageLayout from '@/pages/layout/PageLayout'
import ProductList from '@/pages/product/ProductList'
import ProductInfo from '@/pages/product/ProductInfo'
import ProductEdit from '@/pages/product/ProductEdit'
import UsedAmountProduct from "@/pages/product/UsedAmountProduct";
import ProductRankMonth from "@/pages/product/ProductRankMonth";

const children = [{
  path: '/product/list',
  name: 'ProductList',
  component: ProductList
},
{
  path: '/product/info',
  name: 'ProductInfo',
  component: ProductInfo
}, {
  path: '/product/edit',
  name: 'ProductEdit',
  component: ProductEdit
}, {
    path: '/product/usedAmountProduct',
    name: 'UsedAmountProduct',
    component: UsedAmountProduct
  }, {
    path: '/product/rank',
    name: 'ProductRank',
    component: ProductRankMonth
  }]

export default [{
  path: '/',
  component: PageLayout,
  children
}]



// WEBPACK FOOTER //
// ./src/router/children/product.js